<template>
	<div class="terminalmanagement">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">端管理</div>
					<div class="contentcard">
						<div>
							<a-button type="primary" style="width: 96px;margin-bottom: 15px;" @click="newterminalbtn">新增端</a-button>
							<div>
								<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
									<a-col :span="12" style="text-align: center;">ID</a-col>
									<a-col :span="12" style="text-align: center;">端名称</a-col>
								</a-row>
							</div>
							<div v-if="!terminallist.length">
								<a-alert message="查询结果为空" banner type="info" />
							</div>
							<div style="color: #666;font-size: 14px;" v-for="terminal in terminallist" :key="terminal.id" v-if="terminallist.length">
								<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px 0;">
									<a-col :span="12" style="text-align: center;">{{terminal.id}}</a-col>
									<a-col :span="12" style="text-align: center;">{{terminal.terminal_name}}</a-col>
								</a-row>
							</div>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal title="新增商品" :visible="terminalvisible" @ok="terminalOk" :confirmLoading="confirmLoading" @cancel="terminalCancel">
			<div class="newterminal"><span class="newterminaltext">端名称</span>
				<a-input style="width: 250px;" v-model="newterminal.terminal_name" placeholder="请输入端名称" />
			</div>
		</a-modal>

	</div>
</template>

<script>
	import * as math from "mathjs/lib/cjs"
	export default {
		data() {
			return {
				current: ['salemainpage'],
				openKeys: [''],
				terminallist: [],
				terminalvisible: false,
				confirmLoading: false,
				newterminal: {
					terminal_name: null,
				},
			}
		},
		created: function() {
			this.initialize();
		},
		methods: {
			initialize() {
				var self = this;
				this.$axios.get('/sale/getterminal').then(function(res) {
					self.terminallist = res.data.terminallist;
				});
			},
			newterminalbtn() {
				this.terminalvisible = true;
			},
			terminalOk(e) {
				var self = this;
				if (!this.newterminal.terminal_name) {
					return this.$message.error("端名称不能为空");
				}
				this.confirmLoading = true;
				this.$confirm({
					title: '提示',
					content: '是否新增端',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/sale/savenewterminal', {
							params: self.newterminal
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.confirmLoading = false;
							self.terminalvisible = false;
							self.newterminal = {
								terminal_name: null,
							};
							self.initialize();
						});
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			terminalCancel(e) {
				this.terminalvisible = false;
				this.newterminal = {
					terminal_name: null,
				}
			},
		},
	};
</script>

<style>
	.terminalmanagement .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}

	.newterminal {
		margin-left: 30px;
		margin-bottom: 10px;
	}

	.newterminal .newterminaltext {
		width: 100px;
		font-weight: 700;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// index.vue?57a09dce